/**
 * @generated SignedSource<<2b1377d0fe6524b16600c6e1a2711dd1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LandingPagesV2Table_LandingPageFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ActionColumn_LandingPageFragment" | "ContentsColumn_LandingPageFragment" | "DescriptionColumn_LandingPageFragment" | "TitleColumn_LandingPageFragment" | "UrlPathColumn_LandingPageFragment">;
  readonly " $fragmentType": "LandingPagesV2Table_LandingPageFragment";
};
export type LandingPagesV2Table_LandingPageFragment$key = {
  readonly " $data"?: LandingPagesV2Table_LandingPageFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"LandingPagesV2Table_LandingPageFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "LandingPagesV2Table_LandingPageFragment"
};

(node as any).hash = "81c6900702047efbc76e01c2561e22b9";

export default node;
